import { render, staticRenderFns } from "./ListProperity.vue?vue&type=template&id=deaa1406&scoped=true&"
import script from "./ListProperity.vue?vue&type=script&lang=js&"
export * from "./ListProperity.vue?vue&type=script&lang=js&"
import style0 from "./ListProperity.vue?vue&type=style&index=0&id=deaa1406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deaa1406",
  null
  
)

export default component.exports